var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { ERROR_ICON_SVG, WARNING_ICON_SVG, CHECKMARK_SVG, CLOSE_SVG } from "../assets";
import { Button } from './buttons';
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.defaultState();
        Popup._instance = _this;
        return _this;
    }
    Popup.prototype.defaultState = function () {
        return {
            show: false,
            text: '',
            title: '',
            okButtonText: 'OK',
            type: 'info',
            onCancel: function () {
            },
            onOK: function () {
            }
        };
    };
    Popup.show = function (type, title, text, showCancel, okButtonText, cancelButtonText) {
        var _this = this;
        if (showCancel === void 0) { showCancel = true; }
        if (okButtonText === void 0) { okButtonText = 'OK'; }
        if (cancelButtonText === void 0) { cancelButtonText = 'Cancel'; }
        return new Promise(function (resolve) {
            _this._instance && _this._instance.setState({
                show: true,
                title: title,
                text: text,
                okButtonText: okButtonText,
                cancelButtonText: cancelButtonText,
                type: type,
                onOK: function () {
                    resolve('ok');
                },
                onCancel: showCancel ? function () {
                    resolve('cancel');
                } : undefined
            });
        });
    };
    Popup.contestSubmission = function (slug) {
        return Popup.show('info', '', 'Your Entry was submitted successfully.', false).then(function (action) {
            if (action == 'ok') {
                window.location.assign("/contest/" + slug);
            }
            return action;
        });
    };
    Popup.contestSubmissionError = function (error) {
        return Popup.show('error', 'Your Entry was not submitted successfully.', error, false).then(function (action) {
            if (action == 'ok') {
                window.location.assign("/contest/submit");
            }
            return action;
        });
    };
    Popup.contestSubmissionDuplicate = function () {
        return Popup.show('error', 'Multiple files not allowed.', 'Press OK to try again.', false, 'OK').then(function (action) {
            if (action == 'ok') {
                window.location.assign("/contest/submit");
            }
            return action;
        });
    };
    Popup.giveawaySubmissionError = function (error) {
        return Popup.show('error', 'Your entry was not submitted successfully.', error, false);
    };
    Popup.creditLimit = function (trial_allowed) {
        if (trial_allowed) {
            return Popup.show('warning', '', 'Start downloading samples and sound packs now.', false, 'Get Started for $0.99').then(function (action) {
                if (action == 'ok') {
                    window.location.assign('/pricing');
                }
                return action;
            });
        }
        return Popup.show('warning', '', 'Purchased Credits Required! Get more credits now.', false, 'Get More Credits').then(function (action) {
            if (action == 'ok') {
                window.location.assign('/pricing');
            }
            return action;
        });
    };
    Popup.promoCreditLimit = function () {
        return Popup.show('warning', '', 'Additional Credits Needed! Get more credits here.', false, 'Get More Credits').then(function (action) {
            if (action == 'ok') {
                window.location.assign('/pricing');
            }
            return action;
        });
    };
    Popup.downloadSounds = function (amountOfCredits, allowed, trial_allowed) {
        if (!allowed) {
            return Popup.creditLimit(trial_allowed);
        }
        return Popup.show('warning', '', "Do you want to download all sounds for " + amountOfCredits + " Credits?", true, 'Yes', 'No');
    };
    Popup.removeDrive = function (name) {
        return Popup.show('warning', '', "Are you sure you want to remove drive: " + name + "?", true, 'Remove');
    };
    Popup.reportSound = function (name) {
        return Popup.show('warning', '', "Are you sure you want to report an issue with " + name + "?", true, 'Report');
    };
    Popup.subscribe = function () {
        return Popup.show('warning', 'Get Access', 'Subscribe to a Membership.', true, 'Subscribe');
    };
    Popup.driveLimit = function () {
        return Popup.show('warning', '', 'Drive Limit Reached! Please remove a Drive in order to create a new one.', true, 'Subscribe');
    };
    Popup.upgrade = function () {
        return Popup.show('warning', 'Upgrade', 'Drive Limit Reached! Please upgrade your Membership to access more Drives.', true, 'Upgrade');
    };
    Popup.cancelSubscription = function () {
        return Popup.show('warning', 'Cancel Subscription', 'Before You Go! You will lose access to remaining Credits, Drives, and Favorites. Are you sure?', true, 'Yes, cancel', 'No');
    };
    Popup.prototype.onCancel = function () {
        this.state.onCancel && this.state.onCancel();
        this.setState(this.defaultState());
    };
    Popup.prototype.onOK = function () {
        if (this.state.onOK)
            this.state.onOK();
        this.setState(this.defaultState());
    };
    Popup.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'popup center ' + (this.state.show ? 'show' : '') },
                React.createElement("div", { className: 'popup_inner' },
                    React.createElement("div", null,
                        React.createElement("div", { onClick: this.onCancel.bind(this), className: "close" },
                            React.createElement("img", { style: { float: 'right' }, src: CLOSE_SVG, width: 12, alt: "Close" }))),
                    this.state.type != 'none' && React.createElement("div", { className: 'img' },
                        React.createElement("img", { src: this.state.type == 'error' ? ERROR_ICON_SVG : this.state.type == 'warning' ? WARNING_ICON_SVG : CHECKMARK_SVG, width: 40, alt: "error" })),
                    React.createElement("div", { className: "text-container", style: this.state.type != 'none' ? {} : { marginTop: 20 } },
                        React.createElement("h2", { className: "title" }, this.state.title),
                        this.state.text && React.createElement("p", { className: "text", dangerouslySetInnerHTML: { __html: this.state.text } }),
                        React.createElement("div", { className: "button-div" },
                            React.createElement("div", null,
                                React.createElement(Button, { buttonText: this.state.okButtonText, onClick: this.onOK.bind(this), textColor: '#fff' })),
                            this.state.onCancel &&
                                React.createElement("div", { style: { marginLeft: '2rem' } },
                                    React.createElement(Button, { buttonText: this.state.cancelButtonText || 'Cancel', textColor: '#fff', onClick: this.onCancel.bind(this) }))))))));
    };
    return Popup;
}(React.Component));
export default Popup;
//# sourceMappingURL=Popup.js.map